<template>
    <section class="main">
        <div v-show="isLoading">
            <v-page-loading />
        </div>
        <div v-show="!isLoading">
            <v-page-header :title="getPageTile" />

            <div v-show="hasLoadingError">
                <div class="grid-container">
                    <p class="text-center">
                        {{ loadingError }}
                    </p>
                </div>
            </div>

            <div v-show="!hasLoadingError">
                <div class="grid-container">
                    <div class="grid-x">
                        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                            <div class="wrapper">
                                <v-action-buttons :items="getActionButtons" />

                                <div class="box">
                                    <v-navigation />

                                    <form action="" method="POST" class="filter filter--search" novalidation @submit="onChangePmsTableFilter">
                                        <div class="form-group form-group--search">
                                            <input type="text" name="search" class="form-control form-control--small form-control--search" :placeholder="$t('search.term')" v-model="pmsTableFilter.search" />
                                            <button role="button" type="submit" class="button" :title="$t('search')">
                                                {{ $t('search') }}
                                            </button>
                                        </div>
                                    </form>

                                    <v-table :isLoading="pmsTableLoading" :columns="pmsTableColumns" :items="pmsTableItems" :showShowAll="false" :showShowDeactivatedOnly="true"  :showDeactivatedOnly="pmsTableFilter.show_deactivated_only" @onChangeShowDeactivatedOnly="onChangeShowDeactivatedOnlyPmsTableFilter">
                                        <template slot="name" slot-scope="{ row }">
                                            <span class="table-label">{{ row.profile.lastname }}</span>
                                            <span class="table-description">{{ row.profile.firstname }}</span>
                                        </template>
                                        <template slot="phone" slot-scope="{ row }">
                                            <span class="table-label">
                                                <template v-if="row.profile.communication.mobile">{{ row.profile.communication.mobile }}</template>
                                                <template v-else>-</template>
                                            </span>
                                            <span class="table-description">{{ $t('customers.pm.mobile')}}</span>
                                        </template>
                                        <!-- <template slot="userTrackingAcceptedon" slot-scope="{ row }">
                                            <span :class="{ 'u-color--alert': row.profile.userTrackingAcceptedon == null }">
                                                {{
                                                    row.profile.userTrackingAcceptedon == null
                                                        ? $t('account.message.none_yet')
                                                        : $t('date.on') + ' ' + $moment(row.profile.userTrackingAcceptedon.date).format('DD.MM.YYYY')
                                                }}
                                            </span>
                                            <span
                                                class="table-description"
                                                :class="{ 'u-color--alert': row.profile.userTrackingAcceptedon == null }"
                                            >
                                                {{ $t('account.accepted.dsvgo_consent') }}
                                            </span>
                                        </template> -->
                                        <template slot="location" slot-scope="{ row }">
                                            <template v-if="row.location">
                                                <span class="table-label">{{ row.location.company_name }}</span>
                                                <span class="table-description">{{ row.location.city }}</span>
                                            </template>
                                        </template>
                                        <template slot="update" slot-scope="{ row }">
                                            <template v-if="$store.getters.userHasPermission('pm_update')">
                                                <router-link :to="{ name : 'customers-update-customer-pm', params : { custumor : $route.params.customer, account : row.id } }" class="button button--action button--action--edit button--small" :title="$t('update')">
                                                    {{ $t('update') }}
                                                </router-link>
                                            </template>
                                        </template>
                                    </v-table>
                                    <v-pagination :currentPage="pmsTableCurrentPage" :itemsPerPage="pmsTableItemsPerPage" :items="pmsTableItemsCount" @pageClicked="onChangePmsTablePage" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../../partials/PageHeader';
    import PageLoading from '../../partials/PageLoading';
    import ActionButtons from './../../partials/Foundation/ActionButtons';
    import Navigation from './../Navigation';

    import Table from './../../partials/Foundation/Table';
    import Pagination from './../../partials/Foundation/Pagination';

    export default {
        data() {
            return {
                loading                 : false,
                loadingError            : null,
                customerObject          : {
                    id                      : 0
                },
                pmsTableLoading         : true,
                pmsTableColumns         : [{
                    key                     : 'name'
                }, {
                    key                     : 'phone',
                    width                   : '300px'
                },/* {
                    key                     : 'userTrackingAcceptedon',
                }, */{
                    key                     : 'location',
                    width                   : '300px'
                }, {
                    key                     : 'update',
                    width                   : '46px'
                }],
                pmsTableCurrentPage     : this.$route.query.page || 1,
                pmsTableItemsPerPage    : 6,
                pmsTableItems           : [],
                pmsTableItemsCount      : 0,
                pmsTableFilter          : {
                    search : this.$route.query.search || '',
                    show_deactivated_only : this.$route.query.show_deactivated_only || 0
                }
            };
        },
        components : {
            vPageHeader             : PageHeader,
            vPageLoading            : PageLoading,
            vActionButtons          : ActionButtons,
            vNavigation             : Navigation,
            vTable                  : Table,
            vPagination             : Pagination
        },
        computed : {
            isLoading : function () {
                return this.loading;
            },
            hasLoadingError : function () {
                return this.loadingError !== null;
            },
            getPageTile : function () {
                if (this.customerObject.company_name) {
                    return this.customerObject.company_name;
                }

                return this.$t('pms.title');
            },
            getActionButtons : function () {
                let buttons = [];

                if (this.$store.getters.userHasPermission('pm_create')) {
                    buttons.push({
                        action  : 'create-new',
                        router  : { name : 'customers-create-customer-pm', params : { custumor : this.$route.params.customer } }
                    });
                }

                if (this.$store.getters.userHasPermission('project_create')) {
                    buttons.push({
                        action  : 'create-new',
                        title   : this.$t('project.create_quick.title'),
                        router  : { name : 'customers-create-customer-project', params : { custumor : this.$route.params.customer } }
                    });
                }

                return buttons;
            }
        },
        created : function () {
            this.onUpdateCustomer();
        },
        methods : {
            onUpdateCustomer : function() {
                this.loadingError = null;

                if (!this.$route.params.customer) {
                    this.onUpdatePmsTableItems();
                } else {
                    let promise = this.$api.clearParams()
                        .get('customers/' + this.$route.params.customer + '/get');

                    promise.then((response => {
                        this.customerObject = response.data.data;

                        this.onUpdatePmsTableItems(true);
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onUpdateFilterParameters: function () {
                let query = {
                    'page' : this.pmsTableCurrentPage
                };

                for (let key in this.pmsTableFilter) {
                    if (this.pmsTableFilter[key]) {
                        query[key] = this.pmsTableFilter[key];
                    }
                }

                this.$router.push({query : query});
            },
            onChangePmsTablePage : function (page) {
                this.pmsTableCurrentPage = page;

                this.onUpdatePmsTableItems();
            },
            onChangePmsTableFilter : function (event) {
                event.preventDefault();

                this.pmsTableCurrentPage = 1;

                this.onUpdatePmsTableItems();
            },
            onChangeShowDeactivatedOnlyPmsTableFilter : function (show) {
                this.pmsTableFilter.show_deactivated_only = show;

                this.onUpdatePmsTableItems();
            },
            onUpdatePmsTableItems : function (firstUpdate) {
                if (!firstUpdate) {
                    this.onUpdateFilterParameters();
                }

                let promise = this.$api.clearParams()
                    .addParam('customer', this.$route.params.customer)
                    .addParam('usertype', this.$helpers.usertypes.pm)
                    .addParam('show_deactivated_only', this.pmsTableFilter.show_deactivated_only)
                    .addParam('search', this.pmsTableFilter.search)
                    .setPageParams(this.pmsTableCurrentPage, this.pmsTableItemsPerPage)
                    .setSortParams('createdon', 'desc')
                    .get('accounts');

                promise.then((response => {
                    this.pmsTableItems       = response.data.data;
                    this.pmsTableItemsCount  = response.data.meta.pagination.total;

                    this.pmsTableLoading     = false;
                }).bind(this)).catch((error => {
                    this.pmsTableItems       = [];
                    this.pmsTableItemsCount  = 0;

                    this.pmsTableLoading     = false;
                }).bind(this));

                this.pmsTableLoading = true;
            }
        }
    }
</script>
